import { render, staticRenderFns } from "./previewBankNum.vue?vue&type=template&id=73bf2836&"
import script from "./previewBankNum.vue?vue&type=script&lang=js&"
export * from "./previewBankNum.vue?vue&type=script&lang=js&"
import style0 from "./previewBankNum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "previewBankNum.vue"
export default component.exports